// extracted by mini-css-extract-plugin
export var fadeInOut = "_4g-3";
export var icon = "_4g-4";
export var savedIndicator = "_4g-2";
export var savingIndicator = "_4g-0";
export var spin = "_4g-1";